
/**
 * Returns true if mutual favorite
 * @param {object} participant Participant object (from /events/.../participants)
 * @returns boolean
 */
export function isParticipantMutualFavorite(participant) {
    return participant && participant.is_favorite && participant.favorite_you;
}
